<template>
  <div class="admin-records">
    <div>
      <ul>
        <li :class="{mobile: mobile}">
          <h4>{{ record.displayName }}</h4>
          <div class="icontain">
            <DocumentIcon
              v-if="submitted"
              class="icon"
              @click="toggleDownloadModal"
            />
            <MailIcon
            class="icon"
            @click="toggleMessaging" />
            <PlusIcon
              class="icon"
              @click="toggleEditClassModal"
            />
          </div>
        </li>
      </ul>
      <div v-if="showEditClassModal">
        <EditClassCred
          :record="record"
          @closed="toggleEditClassModal"
        />
      </div>
      <div v-if="showDownloadsModal">
        <ViewDownloadsModal
          :submittedwork="filteredUploads"
          @close="toggleDownloadModal"
        />
      </div>
      <div v-if="showMessageModal">
        <ClassMessage
          :record="record"
          @close="toggleDownloadModal"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/reactivity'
import getPosts from '@/composables/getPosts'
import ViewDownloadsModal from '@/components/ViewDownloadsModal.vue'
import EditClassCred from '@/components/EditClassCred.vue'
import ClassMessage from '@/components/ClassMessage.vue'
import { inject, onMounted, watchEffect } from '@vue/runtime-core'
import { PlusIcon, DocumentIcon, MailIcon } from '@heroicons/vue/outline'

export default {
  components: { PlusIcon, EditClassCred, DocumentIcon, ViewDownloadsModal, MailIcon, ClassMessage },
  props: ['record'],
  setup (props, context) {
    const mobile = ref(false)
    const submitted = ref(false)
    const showEditClassModal = ref(false)
    const showDownloadsModal = ref(false)
    const showMessageModal = ref(false)
    const filteredUploads = ref(null)
    const windowWidth = ref(null)
    const currentUser = inject('currentUser')
    const { myData, error, load } = getPosts()

    load(currentUser.state.grade + '/uploads/learner')

    const showDownloadIcon = (submitter) => {
      if (submitter.lid === props.record.uid) {
        submitted.value = true
      }
    }

    watchEffect(() => {
      filteredUploads.value =
        myData.value ? myData.value.filter(learnerUpload => learnerUpload.lid === props.record.uid)
          : null
      myData.value.forEach(element => {
        showDownloadIcon(element)
      })
    })

    const toggleEditClassModal = ({ load, toasts }) => {
      showEditClassModal.value = !showEditClassModal.value
      if (toasts) {
        context.emit('toasts', { load, toasts })
      }
    }

    const toggleDownloadModal = () => {
      showDownloadsModal.value = !showDownloadsModal.value
    }

    const toggleMessaging = () => {
      showMessageModal.value = !showMessageModal.value
    }

    const handleview = () => {
      windowWidth.value = window.innerWidth
      if (windowWidth.value <= 750) {
        mobile.value = true
        return
      }
      mobile.value = false
    }

    onMounted(() => {
      handleview()
      window.addEventListener('resize', handleview)
    })

    return { mobile, toggleEditClassModal, showEditClassModal, toggleDownloadModal, filteredUploads, error, submitted, showDownloadsModal, toggleMessaging, showMessageModal }
  }
}
</script>

<style>
.admin-records {
  background: #fff;
}
.admin-records div {
  background: white;
  border: 1px solid pink;
  padding: 5px;
}
.admin-records .icontain {
  background: transparent;
  border: none;
  display: flex;
  justify-content: flex-end;
  width: 200px;
}
.admin-records li {
  list-style-type: none;
  background: #eee;
  padding: 10px 20px;
  margin: 5px auto;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.admin-records li.mobile {
  display: flex;
  flex-direction: column;
}
.admin-records li.mobile .icontain {
  flex-direction: column;
  width: 80px;
}
.admin-records li.mobile .icon {
  margin-top: 10px;
}
.admin-records .icon {
  max-width: 17px;
  cursor: pointer;
  margin-left: 25px;
}
.admin-records p, h3, ul {
    padding: 0;
    margin: 0;
}
</style>
